import {BackgroundElementStyles, ElementStyles} from "../elements/ElementStyles";

export const stylesPlanerView = {
  day: {
    borderRadius: BackgroundElementStyles.borderRadius,
    boxSizing: "inherit",
    background: BackgroundElementStyles.background,
    color: BackgroundElementStyles.color,
    padding: BackgroundElementStyles.paddingLabels,
    alignItems: "center",
    cursor: "default",
    margin: "5px",
    height: "1600px",
    flexGrow: 1
  },
  dayPast: {
    borderRadius: BackgroundElementStyles.borderRadius,
    boxSizing: "inherit",
    background: BackgroundElementStyles.backgroundPast,
    color: BackgroundElementStyles.color,
    padding: BackgroundElementStyles.paddingLabels,
    alignItems: "center",
    cursor: "default",
    margin: "5px",
    height: "1600px",
    flexGrow: 1
  },
  selector: {
    width: "200px",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "0px",
    marginBottom: "10px"
  },
  container: {},
  innerContainer: {
    height: "1600px",
    //overflowY: "scroll",
    position: "relative",
    width: "99%"
  },
  line: {
    width: "100%",
    height: "2px",
    background: "gray",
    marginTop: "auto",
    marginBottom: "auto",
    marginRight: "10px",
    marginLeft: "10px"
  },
  label: {
    width: "10px",
    textAlign: "center"
  },
  times: {
    position: "absolute",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    height: "2px"
  },
  timesContainer: {
    position: "absolute",
    width: "100%"
  },
  daysContainer: {
    marginLeft: "20px",
    marginRight: "20px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center"
  },
  hoverItem: {
    position: "absolute",
    background: "var(--accent)",
    //transition: "transform 0.9s ease",
    borderRadius: ElementStyles.borderRadius,
    opacity: "50%",
    zIndex: 5
  },
  item: {
    position: "absolute",
    //background: "#801818",
    //transition: "transform 0.9s ease",
    borderRadius: ElementStyles.borderRadius,
    zIndex: 10
  },
  resize: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    textAlign: "center",
    cursor: "row-resize"
  },
  delete: {
    position: "absolute",
    bottom: 0,
    right: 0,
    cursor: "pointer",
    width: 30
  },
  saveButton: {
    position: "fixed",
    bottom: "30px",
    right: "30px",
    width: "10%",
    height: "5%",
    zIndex: 10,
    background: "red"
  }
};
